<template>
  <b-tab title="Registro Fotográfico" :active="ativo" class="m-0 p-0">
    <div id="screen-form" class="pl-2 pr-2 mt-2">
      <div id="RegistroFotografico">
        <b-container fluid>
          <!-- ::::::::::::::: PARTE SUPERIOR DO RELATORIO ::::::::::::::: -->
          <b-row>
            <b-col cols="3">
              <b-img :src="require('/static/images/netech.png')" fluid alt="Responsive image" width="230" />
            </b-col>

            <b-col cols="6" class="pt-4">
              <h4 class="exo-2 center-text pt-4">{{ registro.titulo }}</h4>
              <h5 class="exo-3 center-text p-0">{{ registro.subtitulo }}</h5>
            </b-col>

            <b-col cols="3" class="pl-5">
              <b-row><p class="m-0 p-0">ID. Relatório</p></b-row>
              <b-row><b-form-input size="sm" v-model="registro.numero" /></b-row>
              <b-row><p class="m-0 p-0">Data</p></b-row>
              <b-row>
                <b-form-datepicker
                  size="sm"
                  v-model="registro.data"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                />
              </b-row>
            </b-col>
          </b-row>
          <div class="borda-image">
            <b-row class="mb-4">
              <b-col cols="12" v-if="isFull()">
                <b-img
                  :src="registro.fotoA == null ? require('/static/images/report.png') : registro.fotoA"
                  class="max-size-img"
                  center
                  fluid
                />
              </b-col>
              <b-col cols="6" v-if="displayed(1)">
                <b-img
                  :src="registro.fotoA == null ? require('/static/images/report.png') : registro.fotoA"
                  class="max-size-img"
                  center
                  fluid
                />
              </b-col>
              <b-col cols="6" class="pl-3" v-if="displayed(2)">
                <b-img
                  :src="registro.fotoB == null ? require('/static/images/report.png') : registro.fotoB"
                  class="max-size-img"
                  center
                  fluid
                />
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="6" v-if="displayed(3)">
                <b-img
                  :src="registro.fotoC == null ? require('/static/images/report.png') : registro.fotoC"
                  class="max-size-img"
                  center
                  fluid
                />
              </b-col>
              <b-col cols="6" class="pl-3" v-if="displayed(4)">
                <b-img
                  :src="registro.fotoD == null ? require('/static/images/report.png') : registro.fotoD"
                  class="max-size-img"
                  center
                  fluid
                />
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="6" v-if="displayed(5)">
                <b-img
                  :src="registro.fotoE == null ? require('/static/images/report.png') : registro.fotoE"
                  class="max-size-img"
                  center
                  fluid
                />
              </b-col>
              <b-col cols="6" class="pl-3" v-if="displayed(6)">
                <b-img
                  :src="registro.fotoF == null ? require('/static/images/report.png') : registro.fotoF"
                  class="max-size-img"
                  center
                  fluid
                />
              </b-col>
            </b-row>
          </div>

          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::: PARTE INFERIOR DO RELATORIO :::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="4" class="mt-2 p-0 pl-3 pr-3">
              <div class="separador-div" :style="{ 'background-color': registro.cor }">
                <strong>INSPETOR</strong>
              </div>
            </b-col>
            <b-col cols="4" class="mt-2 p-0"> </b-col>
            <b-col cols="4" class="mt-2 p-0 pl-3 pr-3">
              <div class="separador-div" :style="{ 'background-color': registro.cor }">
                <strong>CLIENTE</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="text-left ml-2 mr-2 mb-2">
            <b-col cols="4">
              <inspetor-stamp :profissional="registro.inspetor" :preview="stampInspetor" :posicao="'6rem'" key="insp-stamp-pm" />
            </b-col>
            <b-col cols="4" class="m-0 p-0"> </b-col>
            <b-col cols="4">
              <div class="borda-cliente">
                <b-img
                  :src="logoCliente == null ? require('/static/images/sgcq_default.png') : logoCliente"
                  class="rounded-0"
                  fluid
                />
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <registro-modal ref="tRegistro" @loadRegistro="loadRegistro($event)" />
    <imagem-list-modal ref="imgListME" @loadImagem="loadImagem($event)" />
    <!-- ::::::::::::::: COMANDOS DO RELATÓRIO ::::::::::::::: -->
    <div class="menu-acoes p-2">
      <div id="search-bar">
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <h4 class="exo-1 m-0 mr-2">SGCQ</h4>
            <b-form-input id="sgcq-call" type="number" size="sm" class="m-1 p-1" placeholder="Sgcq" v-model="sgcq" />
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="primary" @click="loadEquipamento()">
              <b-icon icon="box-arrow-in-up-right" variant="light" scale="1.1" class="mr-2" />Buscar
            </b-button>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="info" @click="loadDetalhes()">
              <b-icon icon="file-earmark-richtext" variant="light" scale="1.1" class="mr-2" />Detalhes
            </b-button>
            <b-button size="sm" class="ml-2 pl-2 pr-3" variant="warning" v-print="printLaudo">
              <b-icon icon="printer" variant="light" scale="1.1" class="mr-2" />Imprimir
            </b-button>

            <b-form-radio-group
              id="radio-group-1"
              v-model="registro.quantidade"
              name="radio-sub-component"
              buttons
              button-variant="outline-light"
              size="sm"
              class="conf-bar"
            >
              <b-form-radio value="0">Full</b-form-radio>
              <b-form-radio value="1">1</b-form-radio>
              <b-form-radio value="2">2</b-form-radio>
              <b-form-radio value="3">3</b-form-radio>
              <b-form-radio value="4">4</b-form-radio>
              <b-form-radio value="5">5</b-form-radio>
              <b-form-radio value="6">6</b-form-radio>
            </b-form-radio-group>
          </b-form>
        </b-col>
      </div>
    </div>
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import Files from "@/http/files";
import Cliente from "@/models/Cliente";
import Equipamento from "@/models/Equipamento";
import StampCertificado from "@/components/supports/StampCertificado";
import ImagemListModal from "@/components/modals/imagem/ImagemListModal";
import RegistroFotografico from "@/models_reports/RegistroFotografico";
import RegistroFotograficoModal from "@/components/modals/relatorio/RegistroFotograficoModal";

export default {
  name: "RegistroFotograficoReport",

  components: {
    "inspetor-stamp": StampCertificado,
    "imagem-list-modal": ImagemListModal,
    "registro-modal": RegistroFotograficoModal,
  },

  data() {
    return {
      sgcq: 0,
      registro: new RegistroFotografico(),
      ativo: false,
      files: new Files(this.$http),
      cliente: new Cliente(0, "Novo Cliente", "", "", "", "", "", "", ""),
      equipamento: new Equipamento(0, "Novo Equipamento", "", "", "", "", "", "", "", "", ""),
      stampInspetor: null,
      logoCliente: null,
      printLaudo: {
        id: "RegistroFotografico",
        popTitle: "SGCQ - Sistema de Gestão e Controle da Qualidade",
      },
    };
  },

  methods: {
    loadEquipamento() {
      if (this.sgcq != 0 && this.sgcq != "") {
        this.equipamento.update(this.getBySgcq(this.sgcq)[0]);
        this.cliente.update(this.equipamento.cliente);
        this.equipamentoStore.LISTAR_SERVICOS(this.equipamento.sgcq).then(() => {
          let servicoData = new Date(this.getLastServico[0].data);
          this.registro.data = new Date(this.getLastServico[0].data);
          let ano = servicoData.getFullYear();
          this.registro.numero = "RN" + this.getLastServico[0].id + "-" + this.sgcq + "-" + ano + "-FT";
        });
      }

      //carrega a logomarca do cliente
      this.files.downloadLogo(this.cliente.id).then((response) => {
        const reader = new FileReader();
        const blob = new Blob([response]);
        reader.readAsDataURL(blob);
        reader.onload = (e) => {
          this.logoCliente = e.target.result;
        };
      });
    },

    loadDetalhes() {
      this.$refs.tRegistro.call(this.registro);
    },

    isFull() {
      if (this.registro.quantidade === "0") {
        return true;
      } else {
        return false;
      }
    },

    displayed(valor) {
      if (valor <= this.registro.quantidade) {
        return true;
      } else {
        return false;
      }
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipamentoStore = useEquipamentoStore();
    const { getBySgcq } = storeToRefs(equipamentoStore);
    const { getLastServico } = storeToRefs(equipamentoStore);

    return {
      store,
      equipamentoStore,
      getBySgcq,
      getLastServico,
    };
  },
};
</script>

<style lang="scss" scoped>
#screen-form {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 82vh;
}

.exo-1 {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: italic;
  font-size: 1.4rem;
  padding: 0;
  color: white;
}

.exo-2 {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: italic;
  font-size: 1.8rem;
  text-align: center;
}

.exo-3 {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: italic;
  font-size: 1.4rem;
  text-align: center;
}

.separador-div {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  border-radius: 4px;
  color: white;
  text-align: justify; /* For Edge */
  text-align-last: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.borda-cliente {
  border: 1px solid lightgray;
  border-radius: 3px;
  padding-top: 1rem;
  padding-left: 3rem;
  min-height: 8.8rem;
}

.borda-image {
  border: 1px solid lightgray;
  border-radius: 3px;
  padding: 1rem;
  min-height: 74rem;
  min-width: 100%;
}

.menu-acoes {
  background-color: #112a4a;
}

.legend {
  border: 1px solid lightgray;
  font-size: 0.8rem;
}

#sgcq-call {
  width: 6rem;
}

#size-lines {
  width: 4rem;
}

.conf-bar {
  margin-left: 15rem;
}
</style>
